<template>
<div id="app">
<div class="box_z">
  <div class="navbar-box">
    <div>
      <div style="height: 30px"></div>
      <div class="navbarList" v-if="inarr(1)" :class="{active:(xuan==2)}" @click="jupm('huiyuan',2)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/nav/23.png" alt/>
        <div class="iconPic icon-2"></div>
        <div class="box_l_zi">会员</div>
      </div>

      <div class="navbarList" v-if="inarr(7)" :class="{active:(xuan==7)}" @click="jupm('xiaofei',7)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/nav/qiandao.png" alt/>
        <div class="iconPic icon-10"></div>
        <div class="box_l_zi">计次</div>
      </div>

      <el-popover placement="right-start" trigger="hover">
        <div style="cursor: pointer;text-align: center;" class="pop">
          <div :class="idx==7?'in':'is'" @click="qianke('qianke',7,6)">潜客跟进</div>
          <div :class="idx==8?'in':'is'" @click="qianke('vip',8,6)">会员跟进</div>
          <div :class="idx==10?'in':'is'" @click="qianke('caidan',10,6)" v-if="quanxian == 2">采单查询</div>
          <div :class="idx==11?'in':'is'" @click="qianke('minuta',11,6)" v-if="quanxian == 2">名单分配</div>
          <div :class="idx==25?'in':'is'" @click="qianke('wuxiao',25,6)" v-if="quanxian == 2">无效用户</div>
        </div>
        <div slot="reference">
          <div class="navbarList"  v-if="inarr(6)" :class="{active:(xuan==6)}" @click="jupm('follow',6)">
            <div class="tu3"></div>
            <img class="navpic" src="/static/qmsj/img/nav/104.11.png" alt/>
            <div class="iconPic icon-8"></div>
            <div class="box_l_zi">跟进</div>
          </div>
        </div>
      </el-popover>
      <div class="navbarList" v-if="inarr(8)" :class="{active:(xuan==8)}" @click="jupm('haoke1',8)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/nav/kehao.png" alt/>
        <div class="iconPic icon-11"></div>
        <div class="box_l_zi">记录</div>
      </div>

      <div class="navbarList" v-if="inarr(9)" :class="{active:(xuan==9)}" @click="jupm('heyue',9)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/nav/26.png" alt/>
        <div class="iconPic icon-12"></div>
        <div class="box_l_zi">合约</div>
      </div>

      <el-popover placement="right-start" trigger="hover">
        <div style="cursor: pointer;text-align: center;" class="pop">
          <div :class="idx==21?'in':'is'" @click="huod('hdshouye',21,5)">活动首页</div>
          <div :class="idx==22?'in':'is'" @click="huod('hdshezhi',22,5)">创建活动</div>
          <div :class="idx==23?'in':'is'" @click="huod('wqhd',23,5)">往期活动</div>
        </div>
        <div slot="reference">
          <div class="navbarList" v-if="inarr(5)" :class="{active:(xuan==5)}" @click="jupm('hdshouye',5)">
            <div class="tu3"></div>
            <img class="navpic" src="/static/qmsj/img/nav/1.png" alt/>
            <div class="iconPic icon-5"></div>
            <div class="box_l_zi">活动</div>
          </div>
        </div>
      </el-popover>

      <div class="navbarList" v-if="inarr(30)" :class="{active:(xuan==16)}" @click="jupm('actset',16)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/ceping.png" alt/>
        <div class="iconPic icon-4"></div>
        <div class="box_l_zi">测评</div>
      </div>
      <el-popover placement="right-start" trigger="hover" v-show="false">
        <div style="cursor: pointer;text-align: center;" class="pop">
          <div
            v-if="inarr(31)"
            :class="idx==1?'in':'is'"
            @click="qianke('actset',1,16)"
          >测评设置
          </div>
          <div
            v-if="inarr(32)"
            :class="idx==2?'in':'is'"
            @click="qianke('yinxiaolie',2,16)"
          >测评问询
          </div>
          <div
            v-if="inarr(33)"
            :class="idx==3?'in':'is'"
            @click="qianke('cepinyu',3,16)"
          >专家测评
          </div>
          <div
            v-if="inarr(34)"
            :class="idx==4?'in':'is'"
            @click="qianke('actjiesuan',4,16)"
          >活动统计
          </div>
        </div>
        <div slot="reference">
          <div
            class="navbarList"
            :class="{active:(xuan==16)}"
            @click="jupm('',16)"
            v-if="inarr(30)"
          >
            <div class="tu3"></div>
            <img class="navpic" src="/static/qmsj/img/ceping.png" alt/>
            <div class="iconPic icon-7"></div>
            <div class="box_l_zi">测评</div>
          </div>
        </div>
      </el-popover>

      <div class="navbarList"  :class="{active:(xuan==20)}" @click="jupm('wuziye',20)">
        <div class="tu3"></div>
        <img class="navpic" src="/static/qmsj/img/nav/zqb.png" alt/>
        <div class="iconPic icon-19"></div>
        <div class="box_l_zi">物资</div>
      </div>

      <el-popover placement="right-start" trigger="hover">
        <div style="text-align: center;cursor: pointer;" class="pop">
          <div :class="idx==17?'in':'is'" @click="tiaoye('shanglei',17,11)">基础信息</div>
          <div :class="idx==18?'in':'is'" @click="tiaoye('rukgl',18,11)">入库管理</div>
          <div :class="idx==19?'in':'is'" @click="tiaoye('chukgl',19,11)">出库管理</div>
          <div :class="idx==20?'in':'is'" @click="tiaoye('kcshanglei',20,11)">库存管理</div>
        </div>
        <div slot="reference">
          <div class="navbarList" :class="{active:(xuan==11)}" v-if="inarr(27)">
            <div class="tu3"></div>
            <img class="navpic" src="/static/qmsj/img/nav/jinxiaocun.png" alt/>
            <div class="iconPic icon-14"></div>
            <div class="box_l_zi">进销存</div>
          </div>
        </div>
      </el-popover>

      <el-popover placement="right-start" trigger="hover">
        <div class="pop">
          <div :class="idx==12?'in':'is'" @click="xitong('yuangs',12,10)" v-if="inarr(10)">员工设置</div>
          <div :class="idx==13?'in':'is'" @click="xitong('shangpins',13,10)" v-if="inarr(11)">商品设置</div>
          <div :class="idx==16?'in':'is'" @click="xitong('mima',16,10)">密码重置</div>
        </div>
        <div slot="reference">
          <div class="navbarList" :class="{active:(xuan==10)}">
            <div class="tu3"></div>
            <img class="navpic" src="/static/qmsj/img/nav/25.png" alt/>
            <div class="iconPic icon-13"></div>
            <div class="box_l_zi">系统</div>
          </div>
        </div>
      </el-popover>

      <div style="height: 50px"></div>
    </div>
  </div>

  <div class="youce">
    <div class="right_top">
      <div>
<!--        <img style="cursor: pointer;height:29px;" src="/static/qmsj/img/nav2/mh_logo.png" v-if="!isMobile()"-->
<!--             @click="panduanshouye" alt=""/>-->
        <span style="font-weight: bold;font-family: 隶书;font-size: 22px;">正然堂</span>
        <span class="center">{{ centre }}</span>
      </div>
      <div class="t_right_box">
        <div class="zi_btn" v-if="(quanxian==2 || inarr(40))" @click="savesession">品牌运营5S系统</div>
        <el-dropdown @command="handleCommand" style="cursor: pointer;">
          <span class="el-dropdown-link" style="line-height: 40px;">
              {{ username }} ▽
          </span>
          <el-dropdown-menu slot="dropdown">
            <i class="el-icon-arrow-down el-icon--right"></i>
            <el-dropdown-item command="a">
              <p @click="login_out_sys()">注销</p>
            </el-dropdown-item>
            <el-dropdown-item command="b" @click="tiaoye('geren')">个人中心</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="centerbox">
<!--      <img v-if="$route.path == '/'" style="margin: 10% 15%;opacity: 0.15;" src="/static/qmsj/img/nav2/mh_logo.png" alt=""/>-->
      <div v-if="$route.path == '/'"
           style="margin:15% 30%;
           font-weight: bold;
           font-family: 隶书;
           font-size: 200px;
           color: #E6BE8A;">正然堂</div>
      <router-view :userAuthData="userAuthData"></router-view>
    </div>
    <div class="right_bottom" style>
      版权所有：北京中民荣晟科技有限公司 &nbsp; &nbsp;&nbsp; 工信部备案号：京ICP备16051683号-1 &nbsp; &nbsp;&nbsp;
      地址：北京市朝阳区红军营南路15号瑞普大厦C座11层 &nbsp; &nbsp;&nbsp;
      <img
        src="/static/qmsj/img/indexpic/guo.png"
        alt
        style="width: 13px"
      />
      京公网安备：11010502032362号
    </div>
  </div>
</div>

<!-- 访问品牌运营5S系统 -->
<div
  class="modal fade"
  id="gotovi"
  tabindex="-1"
  role="dialog"
  style="background-color:transparent"
  aria-labelledby="myModalLabel"
>
  <div class="modal-dialog" role="document" style="width: 300px;height:100px">
    <div class="modal-content">
      <div class="modal-header" style="padding: 15px 15px 0 15px">
        <h5 class="modal-title" style="color: black;">是否确定访问品牌运营5S系统?</h5>
      </div>
      <!--是否确定访问品牌运营5S系统?-->
      <div class="modal-footer" style="text-align: center">
        <a
          :href="'https://zvi.momyhome.cn/index/login/saas2vi?token='+token"
          style="margin:0" target="_blank" @click="closegotovi" class="btn btn-default btn-sm">确定</a>
        <button type="button" class="btn btn-default btn-sm" style="margin:0" data-dismiss="modal">关闭
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 通告 -->
<el-dialog :visible.sync="noticedialog" width="60%" :close-on-click-modal="false" center>
  <div style="width: 100%;text-align: center;font-weight: bold;font-size: 16px;padding-bottom: 10px;">{{ tong.title }}</div>
  <div style="max-height:400px;min-height: 150px;overflow-x:scroll;">
    <div v-html="tong.content"></div>
  </div>
  <span v-if="tong.url"><a :href="tong.url" target="view_frame">查看详情</a></span>
</el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      xuan: "",
      dialogTableVisible: false,
      dialogTableVisible2: false,
      noticedialog: false,
      tong: "",
      token: "",
      quanxian: "",
      auth: [],
      username: "",
      question: "",
      centre: "",
      idx: 0, //判断选中样式
      glf_auth: "",
      centre_id: "",
      centre_gym: 1,   //判断中心是否具有运动宝贝教案权限 1.无权限  2.有权限
      // 智能客服
      service_dialog: false, //客服系统
      pageSize: 3, //显示问题数量
      chatText: "", //聊天内容
      replyText: "", //客服回复
      replyUrl: "", //跳转到问题页面
      sendText: "",
      news: [],
      list2: [], //选择问题
      list3: [], //常见问题
      list4: [], //热门问题
      hello_list: [], //问候语
      load_more: null, //是否展示加载更多
      c_index: "",
      big_movie: 1,
      userAuthData: '',
      showvirole: 1, //是否显示品牌运营5S系统 官网系统 培训视频等扩展系统
    };
  },
  mounted() {
    let that = this;
    that.token = that.$cookies.get("token");
    $.ajax({
      url: process.env.apiUrl + "saas/index/get_user_auth",
      type: "post",
      dataType: "json",
      async: false,
      data: {
        token: that.token
      },
      success: function (data) {
        that.auth = data.auth;
        that.quanxian = data.jauth;
        that.username = data.username;
        that.centre = data.centre;
        that.glf_auth = data.glf_auth;
        that.centre_id = data.centre_id;
        that.big_movie = data.big_movie;
        that.userAuthData = data
        that.centre_gym = data.centre_gym
        that.showvirole = data.showvirole
        // if (data.jauth == 4) {
        //   that.$router.push("qiandao");
        // }
        if(data.status == 10003 || data.status == 10004 || data.status == 10006){
          $.cookie("token",null)
          // next({path:'/login'})
          that.$router.push("/login");
        }
      }
    });

    this.check_user_info();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    check_user_info() {
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/check_user_info",
        type: "post",
        dataType: "json",
        data: {
          token: that.token
        },
        success: function (data) {
        }
      });
    },
    closegotovi() {
      $("#gotovi").modal("hide");
    },
    check_sign() {
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/exam/check_sign",
        type: "post",
        async: false,
        data: {token: that.token},
        success: function (res) {
          if (res.status == 1) {
            $("#gotoTk").modal();
          } else {
            that.$message.error(res.msg);
          }
        }
      });
    },
    savesession() {
      // let that = this;
      // $.ajax({
      //     url: "http://vi.gymbaby.org/ViIndex/save_session",
      //     type: "post",
      //     async: false,
      //     data: {"username": that.username},
      //     success: function (e) {
      //
      //     }
      // })
      $("#gotovi").modal();
      // let that = this;
      // if (that.glf_auth == 1) {
      // 	that.$message.error("中心管理费已到期,请续约后使用");
      // } else {
      // 	$('#gotovi').modal();
      // }
    },
    panduanshouye() {
      let self = this;
      self.$router.push("/")
      // if (self.quanxian == 4) {
      //   self.$router.push("qiandao");
      // } else if (self.quanxian == 1) {
      //   self.$router.push("jiaoanx");
      // } else if (self.quanxian == 5) {
      //   self.$router.push("jiaoanx2");
      // } else {
      //   self.$router.push("follow");
      // }
    },
    login_out_sys: function () {
      $.cookie("token", null);
      this.tiaoye("login");
    },
    inarr: function (nav_id) {
      return this.auth.indexOf(String(nav_id)) >= 0 ? true : false;
    },
    // 活动板块
    huod(d, index, pid) {
      this.$router.push(d);
      this.idx = index;
      if (pid > 0) {
        this.xuan = pid;
      }
    },
    //潜客跟进
    qianke(d, index, pid) {
      this.$router.push(d);
      this.idx = index;
      if (pid > 0) {
        this.xuan = pid;
      }
    },
    //进销存
    tiaoye(d, index, pid) {
      this.$router.push(d);
      this.idx = index;
      if (pid > 0) {
        this.xuan = pid;
      }
    },
    // 系统设置
    xitong: function (d, index, pid) {
      this.$router.push(d);
      this.idx = index;
      if (pid > 0) {
        this.xuan = pid;
      }
    },
    jupm: function (d, index) {
      this.xuan = index;
      this.$router.push(d);
      this.idx = 0;
    },
    handleCommand(command) {
      if (command == "b") {
        this.$router.push("geren");
      }
    },
    // 点击加载更多
    loader() {
      if (this.pageSize < this.news.length) {
        this.pageSize += 3;
      }
    },

  }
};
</script>
<style>
html {
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
}

/*Chrome下隐藏滚动条，溢出可以透明滚动*/
html::-webkit-scrollbar {
  width: 0px;
}
</style>
<style scoped>
a {
  text-decoration: none;
}

#app {
  min-height: 100vh;
  overflow: hidden;
  background: #ffffff;
}

.jump_m {
  display: inline-block;
  color: rgb(0, 0, 0);
  border: 1px solid darkgray;
  line-height: 21px;
  border-radius: 3px;
  padding: 0 5px;
}

.clearfloat:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfloat {
  zoom: 1;
}

.topbar {
  height: 40px;
  padding-left: 70px;
  padding-right: 70px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}

.logo {
  width: 39px;
  margin-right: 10px;
}

.toptitle {
  font-size: 20px;
  vertical-align: top;
  line-height: 40px;
  color: #354b60;
}

.box_z {
  width: 98%;
  margin: 0 auto;
  position: relative;
  height: 99vh;
  border-radius: 15px;
  overflow: hidden;
}

.navbar-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  height: 99vh;
  overflow-y: scroll;
  -moz-overflow-y: scroll;
  overflow-x: visible;
  -moz-overflow-x: visible;
  /*padding-top:30px;*/
  /*padding-bottom: 30px;*/
  background: #E6BE8A;
  width: 63px;
  border-radius: 15px 0 0 15px;
}

.youce {
  padding-left: 63px;
}

@media screen and (min-width: 1500px) {
  .youce {
    width: 100%;
  }
}

.navbar-box {
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
}

.navbar-box::-webkit-scrollbar {
  width: 0;
}

.navbarList {
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  /*height: 50px;*/
  transition: 0.3s linear;
  cursor: pointer;
}

.navbarList:hover {
  /* padding-left: 4px; */
  background: #f1f1f1;
}

.navbarList:hover .box_l_zi,
.navbarList.active .box_l_zi {
  color: #E6BE8A;
}

.navbarList.active {
  background: #f1f1f1;
}

.navpic {
  margin-left: 15px;
  height: 30px;
  width: 33px;
  vertical-align: top;
}

.tu3 {
  border-radius: 0 3px 3px 0;
  width: 3px;
  height: 40px;
  background-color: #E6BE8A;
  opacity: 0;
  position: absolute;
  top: 10px;
  left: 0;
  transition: 0.3s linear;
}

.navbarList:hover .tu3 {
  opacity: 1;
}

.box_l_zi {
  padding-top: 3px;
  height: 20px;
  width: 63px;
  color: #fff;
  text-align: center;
  font-size: 14px;
}

.right_top {
  height: 8vh;
  line-height: 8vh;
  border-radius: 0 15px 0 0;
  padding-right: 20px;
  padding-left: 20px;
  background: #f1f1f1;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}

.home {
  width: 128px;
  vertical-align: middle;
  margin: 0 30px;
  cursor: pointer;
}

.center {
  font-size: 14px;
  color: grey;
  vertical-align: top;
  margin-left: 25px;
}

.t_right_box {
  display: flex;
  display: -webkit-flex;
  line-height: 5vh;
  align-items: center;
}

.zi_btn {
  display: inline-block;
  background: #E6BE8A;
  border: none;
  border-radius: 16px;
  padding: 3px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.bangzhuBtn {
  width: 62px;
  height: 24px;
}

.centerbox {
  background: #fff;
  height: 80vh;
  overflow-y: auto;
}

.right_bottom {
  font-size: 12px;
  height: 5vh;
  line-height: 5vh;
  width: 100%;
  background: #f1f1f1;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.pop {
  padding: 6px 10px;
  width: 120px;
}

.pop div {
  text-align: center;
  padding: 6px 15px;
  cursor: pointer;
  font-size: 14px;
}

.is:hover {
  color: #E6BE8A;
  padding: 6px 15px;
  border-radius: 5px;
  background: #f1f1f1;
  font-weight: bold;
  font-size: 16px;
}

.in {
  color: #fff;
  padding: 6px 15px;
  border-radius: 5px;
  background: #E6BE8A;
  font-weight: bold;
  font-size: 16px;
}

.in:hover {
  font-size: 16px;
}

.onlineserve {
  font-size: 12px;
}

.yongtou2 {
  float: left;
  width: 100%;
  height: 50px;
  border-radius: 25px;
  overflow: hidden;
}

.yLbox2 {
  margin-left: 57px;
  padding: 17px 10px 17px 10px;
  line-height: 20px;
  font-size: 14px;
  background: #eee;
  border-radius: 10px;
}

.yongtou {
  float: right;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  overflow: hidden;
}

.yLbox {
  margin-right: 57px;
  padding: 17px 10px 17px 10px;
  line-height: 20px;
  font-size: 14px;
  background: #fdb06a;
  border-radius: 10px;
}

.fasongBtn {
  width: 130px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 16px;
  border-radius: 16px;
  float: left;
  cursor: pointer;
  margin-top: 20px;
  background: #fdb06a;
  box-shadow: #f7dcc4 3px 5px 10px;
}

.help {
  font-size: 14px;
  cursor: pointer;
  margin-right: 12px;
}

.help span {
  padding: 4px 7px;
  background-color: #E6BE8A;
  border-radius: 50%;
  color: white;
  margin-right: 3px;
}

.iconPic {
  display: none;
  margin-left: 15px;
  height: 30px;
  width: 33px;
  vertical-align: top;
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  background: #E6BE8A;
}

.icon-1 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/duanxin.png");
  mask-image: url("../../static/qmsj/img/nav/duanxin.png");
}

.icon-2 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/23.png");
  mask-image: url("../../static/qmsj/img/nav/23.png");
}

.icon-3 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/21.png");
  mask-image: url("../../static/qmsj/img/nav/21.png");
}

.icon-4 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/22.png");
  mask-image: url("../../static/qmsj/img/nav/22.png");
}

.icon-5 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/1.png");
  mask-image: url("../../static/qmsj/img/nav/1.png");
}

.icon-6 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/1.png");
  mask-image: url("../../static/qmsj/img/nav/1.png");
}

.icon-7 {
  -webkit-mask-image: url("../../static/qmsj/img/ceping.png");
  mask-image: url("../../static/qmsj/img/ceping.png");
}

.icon-8 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/104.11.png");
  mask-image: url("../../static/qmsj/img/nav/104.11.png");
}

.icon-9 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/104.11.png");
  mask-image: url("../../static/qmsj/img/nav/104.11.png");
}

.icon-10 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/qiandao.png");
  mask-image: url("../../static/qmsj/img/nav/qiandao.png");
}

.icon-11 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/kehao.png");
  mask-image: url("../../static/qmsj/img/nav/kehao.png");
}

.icon-12 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/26.png");
  mask-image: url("../../static/qmsj/img/nav/26.png");
}

.icon-13 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/25.png");
  mask-image: url("../../static/qmsj/img/nav/25.png");
}

.icon-14 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/jinxiaocun.png");
  mask-image: url("../../static/qmsj/img/nav/jinxiaocun.png");
}

.icon-15 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/jiaoan.png");
  mask-image: url("../../static/qmsj/img/nav/jiaoan.png");
}

.icon-16 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/point.png");
  mask-image: url("../../static/qmsj/img/nav/point.png");
}

.icon-17 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/jiankong.png");
  mask-image: url("../../static/qmsj/img/nav/jiankong.png");
}

.icon-18 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/yuyue.png");
  mask-image: url("../../static/qmsj/img/nav/yuyue.png");
}

.icon-19 {
  -webkit-mask-image: url("../../static/qmsj/img/nav/zqb.png");
  mask-image: url("../../static/qmsj/img/nav/zqb.png");
}

.navbarList.active .navpic,
.navbarList:hover .navpic {
  display: none;
}

.navbarList.active .iconPic,
.navbarList:hover .iconPic {
  display: block;
}
</style>
<style>
/*.tanchuang .el-dialog__header {*/
/*padding: 10px 20px 5px;*/
/*color: #fff;*/
/*background: #E6BE8A;*/
/*}*/
.tanchuang .el-dialog__header .el-dialog__title {
  color: #fff;
}

#app .tanchuang .el-dialog .el-dialog__header {
  padding: 10px 20px 5px;
  color: #fff;
  background: #E6BE8A;
  text-align: center;
}

.tanchuang .el-dialog__headerbtn {
  right: 10px;
  top: 10px;
  color: #fff;
}

.tanchuang2 .el-dialog__body {
  padding: 15px;
  height: 270px;
  overflow-y: scroll;
}

.tanchuang2 .el-dialog__footer {
  border-top: 1px solid #e5e5e5;
}

.tanchuang .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>
<!-- 智能客服 -->
<style scoped="scoped">
li {
  list-style: none;
}

.service {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.content {
  width: 90%;
  height: 90%;
  border-radius: 10px;
  margin: 3% auto;
  background-color: white;
  overflow: hidden;
}

.header2 {
  padding: 10px 15px;
  background-color: #f4f3ff;
  box-shadow: 0 2px 0px gainsboro;
}

.header2 div {
  display: inline-block;
  border: 1px solid gainsboro;
  border-radius: 5px;
  padding: 0 5px;
  margin-right: 5px;
}

.header2 span {
  font-size: 15px;
  font-weight: bold;
}

.header2 .close_img {
  width: 20px;
  float: right;
  margin-right: 30px;
  margin-top: 14px;
  cursor: pointer;
}

.header2 .close_img:hover {
  opacity: 0.8;
}

.left_box {
  width: calc(100% - 301px);
  float: left;
}

.left_box .chat_box {
  height: 50vh;
  overflow-y: scroll;
  padding: 50px 15px 10px 30px;
  margin-top: 3px;
  margin-right: 2px;
  border-bottom: 1px solid gainsboro;
}

/* 重置滚动条样式 */
.chat_box::-webkit-scrollbar {
  width: 10px;
}

.chat_box::-webkit-scrollbar-track {
  background-color: #ededed;
  border-radius: 2em;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
}

.chat_box::-webkit-scrollbar-thumb {
  background-color: darkgray;
  border-radius: 2em;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
}

.left_box .reply {
  position: relative;
  margin-bottom: 11px;
}

.left_box .reply .img {
  display: inline-block;
  border: 1px solid gainsboro;
  border-radius: 5px;
  padding: 0 4px;
  margin-right: 12px;
  float: left;
}

.reply .img img {
  width: 25px;
}

.reply .chatroom {
  position: relative;
  margin-left: 50px;
  color: black;
  display: block;
  border: 1px solid darkgray;
  border-radius: 4px;
  padding: 7px 20px;
}

.reply .chatroom a {
  text-decoration: underline;
  margin-left: 20px;
}

.reply .name {
  position: absolute;
  left: 52px;
  top: -15px;
  transform: scale(0.9);
}

.reply .chatroom::before {
  content: "";
  display: block;
  border-right: 7px solid #fff;
  border-left: 7px solid transparent;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 8px;
  left: -14px;
  z-index: 3;
}

.reply .chatroom::after {
  content: "";
  display: block;
  border-right: 8px solid gray;
  border-left: 8px solid transparent;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 7px;
  left: -16.5px;
  z-index: 2;
}

.left_box .ask {
  position: relative;
  float: right;
  margin-bottom: 10px;
}

.left_box .ask .img {
  display: inline-block;
  margin-left: 12px;
  float: right;
}

.ask .img img {
  width: 33px;
}

.ask .chatroom {
  position: relative;
  margin-right: 50px;
  color: black;
  display: block;
  border: 1px solid darkgray;
  border-radius: 4px;
  padding: 7px 20px;
  background-color: #f1f1f1;
}

.ask .name {
  position: absolute;
  right: 52px;
  top: -15px;
  transform: scale(0.9);
}

.ask .chatroom::before {
  content: "";
  display: block;
  border-right: 7px solid transparent;
  border-left: 7px solid #f1f1f1;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 8px;
  right: -14px;
  z-index: 3;
}

.ask .chatroom::after {
  content: "";
  display: block;
  border-right: 8px solid transparent;
  border-left: 8px solid darkgray;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 7px;
  right: -16.5px;
  z-index: 2;
}

.page {
  clear: both;
  text-align: center;
  border-bottom: 1px solid gainsboro;
}

.page .right_top2 {
  margin-top: 5px;
  width: 95%;
  white-space: nowrap;
  overflow-x: scroll;
  display: inline-flex;
  margin-bottom: 3px;
}

.page .right_top2 li {
  margin: 0 20px 5px 0;
  padding: 2px 11px;
  color: #666666;
  border: 1px solid #666666;
  border-radius: 3px;
  float: left;
  cursor: pointer;
}

.page .right_top2 li:hover {
  color: black;
  border-color: black;
}

/* 重置滚动条样式 */
.page .right_top2::-webkit-scrollbar {
  height: 10px;
}

.page .right_top2::-webkit-scrollbar-track {
  background-color: #ededed;
  border-radius: 2em;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
}

.page .right_top2::-webkit-scrollbar-thumb {
  background-color: darkgray;
  border-radius: 2em;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
}

.issue {
  margin: 0 24px 20px 45px;
}

.issue ul {
  float: left;
  display: inline-block;
  width: 260px;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding-bottom: 15px;
  margin-right: 21px;
  margin-top: 20px;
}

.issue ul li {
  margin-top: 15px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666666;
}

.issue ul li:hover {
  color: black;
}

.issue ul span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: #E6BE8A;
  margin: 7px 11px 0;
  float: left;
}

.point {
  text-align: center;
  margin-top: 10px;
  transform: scale(0.9);
}

.point span {
  display: inline-block;
  cursor: pointer;
}

.point img {
  vertical-align: middle;
  margin: -5px 10px 0 0;
}

.point a {
  color: gray;
}

.point a:hover {
  text-decoration: underline;
}

.right_box {
  display: inline-block;
  width: 300px;
  height: 100%;
  border-left: 2px solid #d1d1d1;
  font-weight: bold;
  font-size: 14px;
}

.right_box .right_top2 {
  height: 46vh;
  overflow-y: scroll;
  padding-right: 16px;
  padding-left: 5px;
  padding-top: 10px;
}

.right_box .right_top2 li {
  margin-left: 20px;
  margin-top: 17px;
  padding: 2px 11px;
  color: #666666;
  border: 1px solid #666666;
  border-radius: 3px;
  float: left;
  cursor: pointer;
}

.right_box .right_top2 .active2 {
  color: black;
  border-color: black;
}

.right_bottom2 li:first-child {
  font-size: 15px;
}

.right_box .right_bottom2 {
  border-top: 2px solid #d1d1d1;
  padding: 16px 0 0 23px;
  height: 30vh;
  overflow-y: scroll;
}

.right_box .right_bottom2 li {
  margin-top: 10px;
  cursor: pointer;
}

.right_box .right_bottom2 li:hover {
  color: black;
}

.right_bottom2 .hot_img {
  margin-top: -4px;
  margin-right: 10px;
}

.footer {
  text-align: center;
  width: 100%;
  height: 20vh;
  position: relative;
}

.footer .msg {
  width: 95%;
  display: inline-block;
  height: 100px;
  margin-top: 10px;
  outline: none;
  border: 0;
  resize: none;
}

.footer .btn2 {
  position: absolute;
  right: 35px;
  bottom: 5px;
  display: inline-block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  color: white;
  background-color: #E6BE8A;
  border: 0;
  border-radius: 5px;
  font-size: 15px;
  letter-spacing: 3px;
  cursor: pointer;
  float: right;
  padding-left: 33px;
  text-align: left;
  outline: none;
}

.footer .btn2:hover {
  opacity: 0.9;
}

.footer .trigon {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid white;
  float: right;
  margin: 17px 31px 0 0;
}

/* 媒体查询 */
@media (min-width: 1366px) {
  .chatroom {
    max-width: 600px;
  }
}

@media (min-width: 1920px) {
  .chatroom {
    max-width: 900px;
  }

  .issue ul {
    width: 390px;
  }

  .issue ul li {
    width: 370px;
  }

  .issue ul span {
    margin: 7px 11px 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue